/**
 * Skeleton & Loading Placeholder Generators
 *
 * Centralized module for all skeleton HTML patterns used across the portal
 * for displaying loading states consistently.
 */

/**
 * Generate a skeleton placeholder for estimate field displays.
 * Used when estimate data is still loading or processing.
 *
 * @returns HTML string for estimate skeleton with inline styles
 */
export function estimateSkeleton(): string {
  return '<span class="skeleton skeleton--inline skeleton--estimate"></span>';
}
